export default __webpack_public_path__ + "static/media/Apparel.40da155a.png";